module.exports = __webpack_public_path__ + "img/0b4aaaa18f76f0bd9e7c28dcb7d19a72.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_03.png
// module id = 60
// module chunks = 0